<template>
  <b-card no-body>
    <b-card-header>
      <h3 class="mb-0">Active Beacons</h3>
    </b-card-header>
    <b-card-body style="max-height: 500px; overflow-y: auto;">
      <b-list-group flush>
        <b-list-group-item
          v-for="beacon in activeBeacons"
          :key="beacon.mac"
          class="border-0"
        >
          <b-row align-v="center">
            <b-col>
              <h5 class="mb-1">{{ beacon.patient }}</h5>
              <p class="text-sm mb-0">
                <i class="fas fa-door-open mr-1"></i>{{ beacon.room }}
              </p>
              <small class="text-muted">MAC: {{ beacon.mac }}</small>
            </b-col>
            <b-col cols="auto">
              <b-badge variant="success" pill>Active</b-badge>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
      <div v-if="activeBeacons.length === 0" class="text-center py-5">
        <i class="fas fa-signal fa-3x text-muted mb-3"></i>
        <p class="text-muted">No active beacons detected</p>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: 'ActiveBeacons',
  props: {
    activeBeacons: {
      type: Array,
      default: () => []
    }
  }
}
</script>